import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

// Components
import RemoveFile from '../UploadDocuments/RemoveFile';
import Loading from '../../components/Loading';
import Icon from '../../components/Icon';
import InvalidDocument from './DocumentUploadSenarios/InvalidDocument';
import PassengerNotFound from './DocumentUploadSenarios/PassengerNotFound';
// Hooks
import { useJsonApi } from '../../services/GlobalStore/GlobalStore';

// Icons
// import checkIcon from '../../assets/icons/check-icon-green.svg';
// import crossIcon from '../../assets/icons/error-cross-icon.svg';
import imageIconGreen from '../../assets/icons/image-icon-green.svg';
import imageIconRed from '../../assets/icons/image-icon-red.svg';
import RemoveIconX from '../../assets/icons/remove-x-icon.svg';
import Alert from '../../components/Alert';
// translations
import messages from './messages';

export function removeFileFromState(
  index,
  arrayHelpers,
  progressPercentage,
  setProgressPercentage
) {
  arrayHelpers.remove(index);

  let newProgressPercentage = Object.entries(progressPercentage).filter(
    ([key]) => {
      return key !== index.toString();
    }
  );
  newProgressPercentage = newProgressPercentage.reduce(
    // tslint:disable-next-line:no-shadowed-variable
    (obj, currentValue, index) => {
      obj[index] = currentValue[1];
      return obj;
    },
    {}
  );

  setProgressPercentage(newProgressPercentage);
}

const UploadedFile = ({
  file,
  setFieldValue,
  index,
  arrayHelpers,
  reasons,
  setReasons,
  formatMessage,
  getRequirements,
  progressPercentage,
  feedbackOff,
  setProgressPercentage,
  passengers = [],
  claimId,
  setUpdatedPassenger,
  setUpdatedPassengerId,
  updatedPassenger,
}) => {
  const [isDuplicate, setIsDupicate] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const { data: fileStatus, get: getFileStatus, loading } = useJsonApi(
    `files/${file?.fileId}`,
    {
      credentials: 'include',
      cachePolicy: 'no-cache',
    }
  );
  const status = feedbackOff
    ? { processing_status: 'finished' }
    : fileStatus && fileStatus[0];

  const { data: approvalStatus, get: getApprovalStatus } = useJsonApi(
    `dossierItems/${file?.dossierItemId}/approvalItem`,
    {
      cachePolicy: 'no-cache',
    }
  );
  const approveStatus = approvalStatus && approvalStatus[0];

  const { data: docsInfoReason, get: getDocsInfoReason } = useJsonApi(
    `dossierItems/${file?.dossierItemId}/docsInfoClaimRequests`,
    {
      cachePolicy: 'no-cache',
      queryParams: {
        include: 'reason',
      },
    }
  );

  const reason = docsInfoReason && docsInfoReason[0];

  useEffect(() => {
    if (
      docsInfoReason?.length &&
      !showAlert &&
      (docsInfoReason[0]?.reason?.key === 'document_has_no_text' ||
        docsInfoReason[0]?.reason?.key ===
          'identification_invalid_driving_license' ||
        docsInfoReason[0]?.reason?.key ===
          'identification_invalid_residence_permit' ||
        docsInfoReason[0]?.reason?.key == 'unknown_passenger')
    ) {
      setShowWarning(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docsInfoReason?.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        ((status?.processing_status !== 'finished' &&
          status?.preview_status !== 'Finished') ||
          (status?.processing_status === 'failed' &&
            status?.preview_status === 'Failed') ||
          !loading) &&
        file?.fileId
      ) {
        getFileStatus().then(res => {
          if (res?.errors?.[0]?.status === '404') {
            setIsDupicate(true);
            clearInterval(interval);
          }
        });
      }
    }, 3000);

    if (
      (status?.processing_status === 'finished' ||
        status?.processing_status === 'failed') &&
      (status?.preview_status === 'Finished' ||
        status?.preview_status === 'Failed')
    ) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [status?.processing_status, file?.fileId, status?.preview_status]);

  useEffect(() => {
    if (!feedbackOff && status?.processing_status === 'finished') {
      getApprovalStatus();
    }
    // eslint-disable-next-line
  }, [status?.processing_status]);

  useEffect(() => {
    if (
      (status?.processing_status === 'finished' &&
        approveStatus?.status === 'pending') ||
      approveStatus?.status === 'denied'
    ) {
      getDocsInfoReason();
    }
    // eslint-disable-next-line
  }, [approveStatus?.status, status?.processing_status]);

  useEffect(() => {
    if (!feedbackOff && status?.processing_status === 'finished') {
      getRequirements();
    }
    // eslint-disable-next-line
  }, [approveStatus?.status, status?.processing_status]);

  useEffect(() => {
    if (
      status?.processing_status === 'finished' &&
      approveStatus?.status === 'pending' &&
      !isEmpty(reason) &&
      !Object.keys(reasons).includes(reason?.id)
    ) {
      setReasons({
        ...reasons,
        [reason?.id]: reason?.reason,
      });
    }
    // eslint-disable-next-line
  }, [approveStatus?.status, reason?.reason, status?.processing_status]);

  function afterRemoveFile() {
    removeFileFromState(
      index,
      arrayHelpers,
      progressPercentage,
      setProgressPercentage
    );
  }

  const returnByReason = reason => {
    if (
      reason === 'document_has_no_text' ||
      reason === 'identification_invalid_driving_license' ||
      reason === 'identification_invalid_residence_permit'
    ) {
      return <InvalidDocument setShowWarning={setShowWarning} />;
    } else if (reason === 'unknown_passenger') {
      return (
        <PassengerNotFound
          setShowWarning={setShowWarning}
          passengers={passengers}
          fileId={file?.fileId}
          claimId={claimId}
          setAlertType={setAlertType}
          setShowAlert={setShowAlert}
          setUpdatedPassenger={setUpdatedPassenger}
          setUpdatedPassengerId={setUpdatedPassengerId}
        />
      );
    }
  };

  return (
    <div
      key={`file-${index}-${file?.fileId}`}
      className="flex items-center mb-5 flex-col border-b border-gray-50 border-solid"
    >
      <div className="inline-flex items-center self-start justify-between w-full">
        <div className="inline-flex items-center">
          <div className="mr-10 flex-shrink-0 flex-grow-0">
            {(!status ||
              status?.processing_status === null ||
              status?.processing_status === 'in_progress' ||
              status?.preview_status === 'InProgress') &&
            !isDuplicate ? (
              <Loading
                className="h-10 w-10 flex-shrink-0"
                viewBox="0 0 40 40"
              />
            ) : status?.processing_status === 'failed' ||
              (status?.processing_status === 'finished' &&
                status?.preview_status === 'Finished' &&
                approveStatus?.status === 'denied') ||
              isDuplicate ? (
              <div className="group relative w-max">
                {/* <Icon src={crossIcon} className="w-10 h-10" /> */}
                {isDuplicate ? (
                  <Icon src={RemoveIconX} className="w-16 h-16" />
                ) : (
                  <>
                    <Icon
                      src={updatedPassenger ? imageIconGreen : imageIconRed}
                      className="w-16 h-16"
                    />
                    <span className="z-10 pointer-events-none absolute -top-7 left-0 w-max rounded bg-white px-2 py-1 text-sm font-medium text-gray-50 opacity-0 shadow transition-opacity group-hover:opacity-100">
                      <img src={status?.preview_link} />
                    </span>
                  </>
                )}
              </div>
            ) : status?.processing_status === 'finished' &&
              status?.preview_status === 'Finished' &&
              (approveStatus?.status === 'pending' ||
                approveStatus?.status === 'approved' ||
                approveStatus?.status === 'legal') ? (
              <div className="group relative w-max">
                {/* <Icon src={checkIcon} className="w-10 h-10" /> */}
                <Icon src={imageIconGreen} className="w-16 h-16" />
                <span className="z-10 pointer-events-none absolute -top-7 left-0 w-max rounded bg-white px-2 py-1 text-sm font-medium text-gray-50 opacity-0 shadow transition-opacity group-hover:opacity-100">
                  <img src={status?.preview_link} />
                </span>
              </div>
            ) : null}
          </div>
          <span className="sm:flex-grow truncate text-sm w-full sm:max-w-280">
            {file?.name}
          </span>
        </div>
        <div className="ml-auto">
          <RemoveFile
            item={{
              ...file,
              id: file.dossierItemId,
            }}
            setFieldValue={setFieldValue}
            fieldname={`files.${index}`}
            afterRemoveFile={afterRemoveFile}
          />
        </div>
      </div>
      {!file?.fileId && !file?.dossierItemId ? (
        <>
          <div className="relative w-full px-20 pt-1">
            <div className="overflow-hidden h-5 mb-4 text-xs flex rounded bg-primary-10">
              <div
                style={{ width: `${progressPercentage[index]}%` }}
                className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-primary-400"
              />
            </div>
          </div>
          <span className="sm:flex-grow ml-20 text-gray-300 truncate text-sm w-full sm:max-w-280">
            {formatMessage(messages.isUploading)}
          </span>
        </>
      ) : null}
      {file?.fileId &&
      file?.dossierItemId &&
      status?.processing_status !== 'finished' &&
      status?.processing_status !== 'failed' &&
      !isDuplicate ? (
        <>
          <div className="relative w-full px-20 pt-1 rounded">
            <div className="w-full overflow-hidden top-0 h-4 rounded shim-green" />
          </div>
          <span className="sm:flex-grow ml-20 text-gray-300 truncate text-sm w-full sm:max-w-280">
            {formatMessage(messages.isProcessing)}
          </span>
        </>
      ) : isDuplicate ? (
        <span className="sm:flex-grow ml-20 text-sm text-red-400 w-full sm:max-w-280">
          {formatMessage(messages.duplicateFileNotification)}
        </span>
      ) : null}
      {approveStatus?.status === 'denied' &&
      !isEmpty(docsInfoReason) &&
      showWarning ? (
        <span className="sm:flex-grow ml-20 text-red-400 text-sm w-full">
          {returnByReason(reason?.reason?.key)}
        </span>
      ) : status?.processing_status === 'failed' ? (
        <span className="sm:flex-grow ml-20 text-sm text-red-400 w-full sm:max-w-280">
          {formatMessage(messages.fileProcessingFailed)}
        </span>
      ) : null}
      {showAlert ? (
        <Alert
          level={alertType}
          className="w-full my-20"
          setCloseIcon={setShowAlert}
          iconClassName="cursor-pointer absolute right-80"
        >
          {alertType === 'success'
            ? formatMessage(messages.passengerUpdated)
            : formatMessage(messages.failedPassengerUpdated)}
        </Alert>
      ) : null}
    </div>
  );
};

UploadedFile.propTypes = {
  arrayHelpers: PropTypes.object.isRequired,
  claimId: PropTypes.string || PropTypes.number,
  feedbackOff: PropTypes.bool,
  file: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
  getRequirements: PropTypes.func.isRequired,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  passengers: PropTypes.array,
  progressPercentage: PropTypes.object.isRequired,
  reasons: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
  setProgressPercentage: PropTypes.func.isRequired,
  setReasons: PropTypes.func,
  setUpdatedPassenger: PropTypes.func,
  setUpdatedPassengerId: PropTypes.func,
  updatedPassenger: PropTypes.bool,
};

export default UploadedFile;
